/**
 * @fileoverview Builds the view-model for ReportsView.
 * @module pages/reports/buildReportsViewModel
 */
import { getReportDatePickerLocale } from "./reportLocale.js";

/** @param {Object} ctx @param {Object} handlers @returns {Object} */
export const buildReportsViewModel = (ctx, handlers) => ({
  allowed: ctx.allowed,
  t: ctx.t,
  navigate: ctx.navigate,
  datePickerLocale: getReportDatePickerLocale(ctx.i18n.language),
  reportsOptions: ctx.reportsOptions,
  selectedReportOption: ctx.selectedReportOption,
  selectedEvent: ctx.selectedEvent,
  selectedMemberCompany: ctx.selectedMemberCompany,
  selectedBuyerCompanies: ctx.selectedBuyerCompanies,
  startDate: ctx.startDate,
  endDate: ctx.endDate,
  isStartCalendarOpen: ctx.isStartCalendarOpen,
  setIsStartCalendarOpen: ctx.setIsStartCalendarOpen,
  isEndCalendarOpen: ctx.isEndCalendarOpen,
  setIsEndCalendarOpen: ctx.setIsEndCalendarOpen,
  salaLayouts: ctx.salaLayouts,
  buyerCompaniesData: ctx.buyerCompaniesData,
  memberCompaniesOptions: ctx.memberCompaniesOptions,
  buyerCompaniesOptions: ctx.buyerCompaniesOptions,
  eventsOptions: ctx.eventsOptions,
  loadingEvents: ctx.loadingEvents,
  loadingMemberCompanies: ctx.loadingMemberCompanies,
  loadingBuyerCompanies: ctx.loadingBuyerCompanies,
  loadingExportLogs: ctx.loadingExportLogs,
  loadingLayout: ctx.loadingLayout,
  loadingB2bEvents: ctx.loadingB2bEvents,
  b2bEventsOptions: ctx.b2bEventsOptions,
  b2bBuyerCompaniesOptions: ctx.b2bBuyerCompaniesOptions,
  b2bBuyerUsersOptions: ctx.b2bBuyerUsersOptions,
  selectedB2bEvent: ctx.selectedB2bEvent,
  selectedB2bBuyerCompanies: ctx.selectedB2bBuyerCompanies,
  selectedB2bBuyerUser: ctx.selectedB2bBuyerUser,
  setSelectedB2bBuyerUser: ctx.setSelectedB2bBuyerUser,
  selectedYear: ctx.selectedYear,
  allEventsOptions: ctx.allEventsOptions,
  billed: ctx.billed,
  setBilled: ctx.setBilled,
  selectedEventTypes: ctx.selectedEventTypes,
  setSelectedEventTypes: ctx.setSelectedEventTypes,
  setSelectedMemberCompany: ctx.setSelectedMemberCompany,
  setSelectedBuyerCompanies: ctx.setSelectedBuyerCompanies,
  yearOptions: ctx.yearOptions,
  businessEventSelectProps: ctx.businessEventSelectProps,
  b2bEventSelectProps: ctx.b2bEventSelectProps,
  isDownloadEnabled: ctx.isDownloadEnabled,
  reportI18nKeys: ctx.reportI18nKeys,
  handlers,
});
